import React from 'react'
import '../CSS/Herosection.css'
import CodeLOGO from '../Helpers/Images/CC_1.png';


const Herosection = () => {
  return (
    <div className='classcenter'>
      <img src={CodeLOGO} alt="" />
    </div>
  )
}

export default Herosection